<template lang="pug">
  .service-content
    .service-content-container
      .service-content__desc
        .content__desc__title {{ $t('营销行业人才平台') }}
        .content__desc {{ $t('已经有超过300家品牌方和agency，在使用好快活寻找全职和freelancer人才。') }}
        .content__desc {{$t('同时有超过20000名一线营销人才，在好快活塑造个人IP，分享自身才华。')}}
      .service-container__subTitle
        img(src="@/assets/icon-challenge.png")
        .subTitle {{ $t('企业面临的挑战与痛点') }}

      .service-challenge-container
        .challenge__item
          img(
            src="@/assets/service-icon1.png"
          )
          //- i.iconfont.iconchengben
          .item__title {{ $t('找人困难') }}
          .item__desc {{ $t('营销行业受营销季节性波动影响，有大量Freelancer招聘需求。需求方多数情况只能通过熟人介绍等传统方式寻找相关人才，人才缺口无法得到满足。') }}
        .challenge__item
          img(
            src="@/assets/service-icon2.png"
          )
          //- i.iconfont.iconziyuan
          .item__title {{ $t('合规性低') }}
          .item__desc {{ $t('多数营销企业针对兼职招聘没有明确的流程管理。从合同签订，项目流程管理，结案，到支付环节均存在一定的合规风险。') }}
        //- .challenge__item
        //-   img(
        //-     src="@/assets/service-challenge-img.png"
        //-   )
        //-   i.iconfont.iconxiaoshuai
        //-   .item__title {{ $t('效率低下') }}
        //-   .item__desc {{ $t('支付给个人导致结算笔数较多，企业内部财务流程消耗较多的人力，精力及时间成本，而这些背后其实是另外一笔财务成本。') }}
      .service-container__subTitle
        img(src="@/assets/icon-project.png")
        .subTitle {{ $t('复歌的解决方案') }}

      .service-solution-container
        .solution-item
          img(
            src="@/assets/freelancer-item-1.png"
          )
          .solution-content
            .solution-content__title {{ $t('人才触达') }}
            .solution-content__desc {{ $t('直接触达 20000+ 一线营销人才，平台极速匹配，加速企业人才引进，而且平台会审核并提供更贴合甲方需求的简历和作品，简历质量有保证。')}}

        .solution-item
          .solution-content
            .solution-content__title {{ $t('合规降本') }}
            .solution-content__desc {{ $t('人才统一签约和代付并提供增值税专用发票，节约90%以上税费成本。')}}
          img(
            src="@/assets/freelancer-item-2.png"
          )
    
</template>

<script>
import CaseSample from '@/components/CaseSample'
export default {
  components: {
    CaseSample
  },
  data () {
    return {
      
    }
  }
}
</script>
<style lang="stylus" scoped>
.service-challenge-container
  justify-content: center
  .challenge__item
    margin-right: 32px
    &:last-of-type
      margin-right: 0
</style>
